import { render, staticRenderFns } from "./ipblacklist.vue?vue&type=template&id=631b3041&"
import script from "./ipblacklist.vue?vue&type=script&lang=ts&"
export * from "./ipblacklist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports